var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvaliationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25 0H10C4.47715 0 0 4.47715 0 10V25C0 30.5228 4.47715 35 10 35H25C30.5228 35 35 30.5228 35 25V10C35 4.47715 30.5228 0 25 0Z",
    fill: "#D3FF9A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5467 12.3616L19.6128 14.4919C19.7036 14.6522 19.8271 14.7915 19.9752 14.901C20.1233 15.0105 20.2927 15.0877 20.4725 15.1275L22.403 15.4484C23.6372 15.6544 23.9282 16.5502 23.0386 17.4335L21.5377 18.9345C21.4063 19.0818 21.3098 19.2567 21.2553 19.4464C21.2008 19.636 21.1898 19.8355 21.223 20.0301L21.654 21.8903C21.9929 23.3619 21.212 23.9315 19.9109 23.1615L18.1014 22.0902C17.9161 21.9947 17.7106 21.9449 17.5022 21.9449C17.2937 21.9449 17.0882 21.9947 16.9029 22.0902L15.091 23.1592C13.7961 23.9277 13.009 23.3528 13.347 21.8903L13.7766 20.0324C13.8098 19.8379 13.7987 19.6384 13.7442 19.4487C13.6898 19.2591 13.5933 19.0841 13.4619 18.9369L11.9619 17.4335C11.0785 16.5497 11.3628 15.654 12.5975 15.4484L14.528 15.1275C14.7068 15.0868 14.8752 15.0093 15.0223 14.8999C15.1694 14.7904 15.2921 14.6515 15.3825 14.4919L16.4467 12.3616C17.0277 11.2057 17.9719 11.2057 18.5467 12.3616Z",
    fill: "#D3FF9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaliationIcon);
export default __webpack_public_path__ + "static/media/avaliation-icon.9d9bd0a26ce40d6bf6c75f4ea09e4eba.svg";
export { ForwardRef as ReactComponent };